import { NgModule, Optional, SkipSelf } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { nameof } from '@symphony-solo/shared/utils/src';
import { PaymentCardsEffects } from './payment-cards.effects';
import { IPaymentCardsFeature } from './payment-cards.feature.state';
import { paymentCardsReducer } from './payment-cards.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(nameof<IPaymentCardsFeature>('paymentCardsFeature'), paymentCardsReducer),
    EffectsModule.forFeature([PaymentCardsEffects]),
  ],
})
export class PaymentCardStateModule {
  public constructor(
    @Optional()
    @SkipSelf()
    parentModule: PaymentCardStateModule
  ) {
    if (parentModule) {
      throw new Error('PaymentCardsStateModule is already loaded. Import it in the AppModule only');
    }
  }
}
